import App from "./App";
import { createRoot } from "react-dom/client";
import { Log } from 'oidc-client-ts';
import "styles/main.scss";

Log.setLogger(console);

const root = createRoot(document.getElementById("root")!);
root.render(<App />);